import { render, staticRenderFns } from "./Show.vue?vue&type=template&id=e334f74e&scoped=true"
import script from "./Show.vue?vue&type=script&setup=true&lang=js"
export * from "./Show.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Show.vue?vue&type=style&index=0&id=e334f74e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e334f74e",
  null
  
)

export default component.exports